import { I18n } from '@calendly/i18n';
import { useCalendarData } from '@calendly/ui/hooks/use-calendar-data';
import { useDeviceType } from '@calendly/ui/hooks/use-device-type';
import classNames from 'classnames';
import moment from 'moment-timezone';
import PropTypes from 'prop-types';
import { useState, forwardRef } from 'react';
import Day from 'components/core/calendar/day';
import Navigation from 'components/core/calendar/navigation';
const titleCss = "tgwtitp";
const Title = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(titleCss, props.className)} />;
});
const wrapperIsTabletUpCss = "wdvqtt1";
const wrapperCss = "wrb1a1n";
const Wrapper = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  const isTabletUp = useDeviceType('isTabletUp');
  return <Component ref={ref} {...restProps} className={classNames(wrapperCss, {
    [wrapperIsTabletUpCss]: isTabletUp
  }, props.className)} />;
});
const headingCss = "hx48y5w";
const Heading = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'th';
  return <Component ref={ref} {...restProps} className={classNames(headingCss, props.className)} />;
});
const tableIsTabletUpCss = "tc51ycz";
const tableCss = "t2m0s83";
const Table = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'table';
  const isTabletUp = useDeviceType('isTabletUp');
  return <Component ref={ref} {...restProps} className={classNames(tableCss, {
    [tableIsTabletUpCss]: isTabletUp
  }, props.className)} />;
});
const headerCss = "hj7jj0o";
const Header = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(headerCss, props.className)} />;
});
const Week = ({
  week,
  selectedDays,
  toggleDay
}) => {
  const dayNames = I18n.t('date.day_names_hash');
  return <tr>
      {week.map(({
      id,
      text,
      isBeforeToday,
      isToday,
      isInCurrentMonth,
      wday
    }) => <Day key={id} bookable={!isBeforeToday} hidden={!isInCurrentMonth} disabled={isBeforeToday} selected={selectedDays.includes(id)} today={isToday} onClick={() => toggleDay(id)}>
          <span name={text} aria-label={`${dayNames[wday]} ${text}`}>{text}</span>
        </Day>)}
    </tr>;
};
const Calendar = ({
  timezone,
  selectedDays,
  toggleDay
}) => {
  const now = moment().tz(timezone).format('YYYY-MM');
  const [currentMonthId, setCurrentMonthId] = useState(selectedDays[0] || now);
  const {
    title,
    weekdays,
    weeks,
    nextMonthId,
    prevMonthId,
    isCurrentMonth
  } = useCalendarData(moment(currentMonthId).format('YYYY-MM'), timezone);
  return <div data-component="calendar">
      <Header data-component="calendar-header">
        <Title aria-live="assertive" aria-atomic="true" role="status">{title}</Title>
        <Navigation backwardDisabled={isCurrentMonth} onBackward={() => setCurrentMonthId(prevMonthId)} onForward={() => setCurrentMonthId(nextMonthId)} />
      </Header>
      <Wrapper>
        <Table>
          <thead>
            <tr>
              {weekdays.map(weekday => <Heading key={weekday}>{weekday}</Heading>)}
            </tr>
          </thead>
          <tbody data-testid="calendar-table">
            {weeks.map(week => <Week key={week[0].id} selectedDays={selectedDays} toggleDay={toggleDay} week={week} />)}
          </tbody>
        </Table>
      </Wrapper>
    </div>;
};
Calendar.propTypes = {
  timezone: PropTypes.string.isRequired,
  selectedDays: PropTypes.arrayOf(PropTypes.string).isRequired,
  toggleDay: PropTypes.func.isRequired
};
export default Calendar;

require("./calendar.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./calendar.js");